/**
 * Meliusly first-party Customer Photos & Videos widget.
 * Renders Fera.ai public media with the exact markup/classes the live
 * headless site showed; layout is pinned by the scoped rules in
 * meliusly-app.css. Paging via Show More; minimal overlay lightbox.
 */
(function () {
  var holder = document.querySelector('[data-mel-fera]');
  if (!holder || holder.dataset.melFeraDone) return;
  holder.dataset.melFeraDone = '1';
  var PK = holder.dataset.pk;
  if (!PK) return;

  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  var perPage = parseInt(isMobile ? holder.dataset.mobileCount : holder.dataset.desktopCount, 10) || 12;
  var perRow = isMobile ? 2 : 6;
  var offset = 0;
  var root, content, moreBtn;

  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    for (var k in (attrs || {})) e.setAttribute(k, attrs[k]);
    return e;
  }

  function tileSize() {
    var w = Math.min(root.clientWidth || 1260, 1260) - 0;
    var gap = 20;
    return Math.floor((w - (perRow - 1) * gap) / perRow);
  }

  function render(items) {
    var size = tileSize();
    var row = null;
    items.forEach(function (m, i) {
      if (i % perRow === 0) {
        row = el('div', 'fera-customerMedia-content-row');
        row.style.marginTop = '20px';
        content.appendChild(row);
      }
      var isVideo = !!(m.video_url || (m.thumbnail_url || '').indexOf('customer_videos') > -1);
      var tile = el('div', 'fera-mediaGallery-item fera-mediaGallery-item--' + (isVideo ? 'video' : 'photo') + ' fera-customerMedia-thumbnail', { 'data-id': m.public_id || m.id });
      tile.style.cssText = 'margin-right:20px;width:' + size + 'px;height:' + size + 'px;';
      if ((i + 1) % perRow === 0) tile.style.marginRight = '0';
      var img = el('img', 'fera-mediaGallery-item-thumbnail', {
        alt: isVideo ? 'Review video' : 'Review photo',
        src: m.thumbnail_url || m.image_thumbnail_url || m.image_url,
        loading: 'lazy'
      });
      tile.appendChild(img);
      if (isVideo) {
        var play = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        play.setAttribute('class', 'fera-video-play-btn');
        play.setAttribute('viewBox', '0 0 89 88');
        play.setAttribute('width', '89'); play.setAttribute('height', '88');
        play.innerHTML = '<rect fill="white" fill-opacity="0.2" height="87" rx="43.5" width="87" x="0.8" y="0.5"></rect><path d="M63.8 41.4L36.9 24.9a2.6 2.6 0 0 0-4 2.2v33a2.6 2.6 0 0 0 4 2.2l26.9-16.5a2.6 2.6 0 0 0 0-4.4Z" fill="white"></path><rect height="87" rx="43.5" stroke="white" width="87" x="0.8" y="0.5" fill="none"></rect>';
        tile.appendChild(play);
      }
      tile.addEventListener('click', function () { openLightbox(m, isVideo); });
      row.appendChild(tile);
    });
  }

  function openLightbox(m, isVideo) {
    var ov = el('div', 'mel-fera-lightbox');
    ov.style.cssText = 'position:fixed;inset:0;z-index:400;background:rgba(0,0,0,0.85);display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out;';
    var media;
    if (isVideo && (m.video_url || m.file_url)) {
      media = el('video', '', { controls: '', autoplay: '', playsinline: '' });
      media.src = m.video_url || m.file_url;
    } else {
      media = el('img', '', { alt: 'Customer photo' });
      media.src = m.image_url || m.original_url || m.thumbnail_url;
    }
    media.style.cssText = 'max-width:92vw;max-height:88vh;object-fit:contain;border-radius:6px;';
    ov.appendChild(media);
    ov.addEventListener('click', function (e) { if (e.target === ov) ov.remove(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', esc); } });
    document.body.appendChild(ov);
  }

  function fetchPage() {
    var u = 'https://api.fera.ai/v2/public/customer_media.json?offset=' + offset + '&limit=' + perPage +
      '&only_photos=false&only_videos=false&media_source=all&public_key=' + encodeURIComponent(PK);
    return fetch(u).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; });
  }

  function loadMore() {
    fetchPage().then(function (items) {
      if (!items.length) { if (moreBtn) moreBtn.style.display = 'none'; return; }
      render(items);
      offset += items.length;
      if (items.length < perPage && moreBtn) moreBtn.style.display = 'none';
    });
  }

  function mount() {
    root = el('div', 'fera-storeCustomerMedia');
    var h2 = el('h2', 'fera-customerMedia-header');
    h2.textContent = holder.dataset.heading || 'Customer Photos & Videos';
    root.appendChild(h2);
    content = el('div', 'fera-customerMedia-content');
    root.appendChild(content);
    var footer = el('div', 'fera-customerMedia-footer');
    moreBtn = el('button', 'fera-customerMedia-loadMoreBtn', { type: 'button' });
    moreBtn.textContent = 'Show More';
    moreBtn.addEventListener('click', loadMore);
    footer.appendChild(moreBtn);
    root.appendChild(footer);
    holder.appendChild(root);
    loadMore();
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); mount(); }
    }, { rootMargin: '600px' });
    io.observe(holder);
  } else {
    mount();
  }
})();
